export default "__VITE_ASSET__D0Wi25r___"